<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-inexorange hover:text-white" :href="route('contacts')">Cliente</inertia-link>
      <span class="text-white font-medium">/Crear</span>
    </h1>
    <div class="bg-transparent rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.nombres" :error="form.errors.nombres" class="pr-6 pb-8 w-full lg:w-1/3" label="Nombres" required/>
          <text-input v-model="form.apellidos" :error="form.errors.apellidos" class="pr-6 pb-8 w-full lg:w-1/3" label="Apellidos" required/>
          <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-1/3" label="E-mail" required/>
        </div>
        <div class="px-8 py-4 bg-transparent flex justify-end items-center">
          <loading-button :loading="form.processing" style="color: white" class="px-8 py-4 btn-indigoOrange" type="submit">Agregar Cliente</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Agregar Cliente' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    users: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        nombres: null,
        apellidos: null,
        porcentaje: null,
        organization_id: null,
        id_cuenta: null,
        id_inversion: null,
        email: null,
        monto: null,
        user_id: null,
        estado: 'SI',
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('contacts.store'))
    },
  },
}
</script>
